(() => {
  const initTrustpilotSlider = (root) => {
    if (!root || root.dataset.trustpilotSliderReady === 'true') return;
    if (typeof window.Swiper === 'undefined') return;

    const sliderEl = root.querySelector('[data-trustpilot-slider]');
    if (!sliderEl) return;

    const prevEl = root.querySelector('[data-trustpilot-prev]');
    const nextEl = root.querySelector('[data-trustpilot-next]');
    const paginationEl = root.querySelector('[data-trustpilot-pagination]');
    const computedStyles = window.getComputedStyle(root);
    const gap = Number.parseFloat(computedStyles.getPropertyValue('--trustpilot-showcase-gap')) || 18;

    const options = {
      slidesPerView: 1.15,
      spaceBetween: gap,
      speed: 520,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      updateOnWindowResize: true,
      breakpoints: {
        750: {
          slidesPerView: 2,
        },
        990: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 4,
        },
      },
    };

    if (prevEl && nextEl) {
      options.navigation = {
        prevEl,
        nextEl,
      };
    }

    if (paginationEl) {
      options.pagination = {
        el: paginationEl,
        clickable: true,
      };
    }

    new window.Swiper(sliderEl, options);
    root.dataset.trustpilotSliderReady = 'true';
  };

  const initAllTrustpilotSliders = () => {
    document.querySelectorAll('[data-trustpilot-carousel]').forEach((root) => initTrustpilotSlider(root));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllTrustpilotSliders, { once: true });
  } else {
    initAllTrustpilotSliders();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initTrustpilotSlider(event.target.querySelector('[data-trustpilot-carousel]'));
  });
})();
